

































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import { HttpError } from '@/models/http.error';
import {
  countriesState,
  countryModule,
  userModule,
  userState
} from '@/utils/store-acessor';
import { TablePlatformSettingsModel } from '@/models/platform-settings.model';
import { UserModel } from '@/models/user.model';
import PopupCompleteProfile from '../../Popups/PopupCompleteProfile.vue';

@Component({
  components: { PopupCompleteProfile }
})
export default class ProfilePlatformSettings extends Vue {
  // @ts-ignore
  @Ref() platformForm: VForm;
  @countryModule.Getter('timezones') timezones!: string[];
  @userModule.Getter('platformSettings')
  platformSettings!: TablePlatformSettingsModel;
  @userModule.Getter('hasPlatformSettings') userHasPlatformSettings!: boolean;
  @userModule.Getter('user') user!: UserModel;

  valid: boolean = false;
  submitting: boolean = false;
  error: HttpError | null = null;

  snackbarVisibility: boolean = false;
  snackbarColor: string | null = null;
  snackbarText: string = '';
  buttonTrigger: boolean = false;

  async mounted() {
    await countriesState.fetchTimezones();
  }

  TogglePopup(){
    this.buttonTrigger = false;
  }

  async onSubmit() {
    if (!this.user?.contestant?.id) {
      // this.snackbarVisibility = true;
      // this.snackbarColor = 'red';
      // this.snackbarText = 'profile.messages.complete_your_profile';
      this.buttonTrigger = true;
      return;
    }
    if (this.platformForm.validate()) {
      this.submitting = true;
      try {
        await userState.setPlatformSettings();
        this.snackbarVisibility = true;
        this.snackbarColor = 'green';
        this.snackbarText = 'profile.messages.update_success';
      } catch (error) {
        this.snackbarVisibility = false;
        this.snackbarColor = 'red';
        this.snackbarText = 'profile.messages.update_failed';
      } finally {
        this.submitting = false;
      }
    } else {
      this.snackbarVisibility = true;
      this.snackbarColor = 'red';
      this.snackbarText = 'profile.messages.update_failed';
    }
  }
}
